import {
    initializeFirebase,
    FirebaseAuth,
    FirebaseDatabase,
    FirestoreDatabase
} from "refine-firebase";
import { getStorage } from 'firebase/storage';
import { initializeApp } from "firebase/app";

const firebaseConfig = {
    apiKey: "AIzaSyBjPn2Bki1Vn-5fyYRCj4p6MSh5kUGTp3w",
    authDomain: "streamer-studio-1c277.firebaseapp.com",
    projectId: "streamer-studio-1c277",
    storageBucket: "streamer-studio-1c277.appspot.com",
    messagingSenderId: "714510458716",
    appId: "1:714510458716:web:e236b16eaf869d57be6b99",
    measurementId: "G-C3J3GPJNKE"
  };

export const firebaseApp = initializeFirebase(firebaseConfig);

export const firebaseAuth = new FirebaseAuth();

export const firestoreDatabase = new FirestoreDatabase();

export const firebaseDatabase = new FirebaseDatabase();

export const storage = getStorage(initializeApp(firebaseConfig));